import { makeStyles } from "tss-react/mui"
import {
  amber,
  green,
  lightBlue,
  lime,
  orange,
  red
} from "../../../../mp-core/themes/palette"
import { iconButtonClasses, iconClasses } from "@mui/material"

type StyleParams = {
  disabled?: boolean
}

type RuleName = "root" | "button" | "selectedButton" | "faceIcon"

export const useStyles = makeStyles<StyleParams, RuleName>()(
  ({ spacing, mixins }, { disabled = false }, classes) => ({
    root: {
      flexDirection: "row",
      gap: spacing(2),

      [`&:hover .${classes.button}:not(:hover):not(.${classes.selectedButton}) .${classes.faceIcon}`]:
        {
          ...(!disabled && { color: lightBlue[200] })
        },
      [`&:focus-within .${classes.button}:not(:focus-visible):not(.${classes.selectedButton}) .${classes.faceIcon}`]:
        {
          ...(!disabled && { color: lightBlue[200] })
        },
      [`&:focus-within .${classes.button}:focus-visible:not(.${classes.selectedButton}) .${classes.faceIcon}`]:
        {
          ...(!disabled && { color: lightBlue[600] })
        }
    },
    button: {
      [`&.${iconButtonClasses.sizeMedium}`]: {
        width: "30px",
        height: "30px",
        padding: 0,

        [`& .${iconClasses.root}`]: {
          fontSize: "28px"
        }
      },
      "&&:hover": {
        border: "none",
        outline: "none",
        boxShadow: "none !important",
        backgroundColor: "transparent"
      },
      "&&:focus-visible": {
        ...mixins.focusRing.shadow,
        boxShadow: `${mixins.focusRing.shadow.boxShadow} !important`,
        border: "none",
        color: lightBlue[600],
        backgroundColor: "transparent"
      }
    },
    selectedButton: {},
    faceIcon: {
      color: lightBlue[500],

      cursor: "pointer",
      ...(disabled && { pointerEvents: "none" })
    },
    notSelectedFaceIcon: {
      color: lightBlue[200],

      "&:hover": {
        ...(!disabled && { color: lightBlue[600] })
      }
    },
    pouting: {
      color: red[500]
    },
    frown: {
      color: orange[600]
    },
    meh: {
      color: amber[700]
    },
    smile: {
      color: lime[600]
    },
    grin: {
      color: green[500]
    }
  })
)
